angular.module('lsnBase.deprecated.models')
  .factory('ApplicationAllowedChangesRisksModel', ['LsnApplicationAllowedChangesRisksModelV1',
    function(LsnApplicationAllowedChangesRisksModelV1) {
      return LsnApplicationAllowedChangesRisksModelV1;
    }
  ]);